const APP_NAME = 'vibe-public-app';

let resolveReady;
const ready = new Promise((resolve) => {
  resolveReady = resolve;
});

export function whenBigBrainReady() {
  return ready;
}

export function initBigBrain() {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.BigBrain === 'function') {
      resolveReady();
      return;
    }

    const env = (import.meta.env && import.meta.env.VITE_BIGBRAIN_ENV) || 'production';

    import('@mondaydotcomorg/bigbrain/BigBrainWeb')
      .then(({ bigBrain }) => {
        try {
          if (typeof window.BigBrain !== 'function') {
            const client = bigBrain(env, APP_NAME);
            window.BigBrain = (action, eventName, data) => {
              if (action !== 'track') return undefined;
              try {
                const result = client.track(eventName, data ?? {});
                // client.track POSTs to the collector; swallow the async rejection so a failed
                // beacon never becomes an unhandledrejection the error-reporter ships as an app error.
                if (result && typeof result.then === 'function') result.catch(() => {});
                return result;
              } catch {}
            };
          }
        } catch {}
        resolveReady();
      })
      .catch(() => resolveReady());
  } catch {
    resolveReady();
  }
}
